import { SortDirection, sortArray, nameofFactory } from "@core/utils";
import { SelectFieldOption } from "@generation/core";

export const sortOptionArray = (result: number[], sortDirection: SortDirection) => {
  return sortArray(
    result.map((item) => ({
      label: String(item),
      value: String(item)
    })),
    nameofFactory<SelectFieldOption>()("label"),
    sortDirection
  );
};
